import { environment } from '@gaodun.com/gtools';
import { COMP_TYPE_SWIPER, INTERACTION_TITLE_LIST } from "./constants";
import commonPool from "../store/commonPool";
var gdPrefix = 'gd';
import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
import localeData from 'dayjs/plugin/localeData';
export var getPrefixCls = function getPrefixCls(name) {
  return "".concat(gdPrefix, "-").concat(name);
};

// 得到base64格式
export var getBase64 = function getBase64(img, callback) {
  var reader = new FileReader();
  reader.addEventListener('load', function () {
    return callback(reader.result);
  });
  reader.readAsDataURL(img);
};

// 生成唯一标识
export var guid = function guid() {
  return 'axxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
};

/**
 * 获取接口请求环境前缀
 */
export var getApiEnv = function getApiEnv() {
  var apiEnv = environment.getApiEnv();
  // const apiEnv = 't-';
  return apiEnv;
};

/**
 * 获取环境变量
 */
export var getEnv = function getEnv() {
  // 暂时为了兼容小程序，后续需要改两套
  var env = environment.getEnv();
  // const env = 't-';
  return env;
};

/**
 * 获取domain
 * @param host host
 * @param length 将要返回的长度
 * @returns {string} domain
 */
export var getDomain = function getDomain() {
  var host = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.hostname;
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var arr = host.split('.');
  if (arr.length > length) {
    return '.' + arr.slice(arr.length - length, arr.length).join('.');
  }
  return '.' + host;
};

/**
 * 获取接口域名前缀
 */
export var getPrefix = function getPrefix() {
  var preFix = getApiEnv();
  return "https://".concat(preFix);
};

/**
 * 获取网关host
 */
export var getApigatewayHost = function getApigatewayHost() {
  var prefix = getPrefix();
  return "".concat(prefix, "apigateway").concat(getDomain());
};

/**
 * 获取带有环境前缀的字符串
 */
export var getEnvStr = function getEnvStr(str) {
  var preFix = getApiEnv();
  return "".concat(preFix).concat(str);
};

/**
 * 处理url特殊参数
 * @scene参数在url中object对象处理
 */
export var getUrlParams = function getUrlParams(search) {
  var str = search;
  var str2 = {};
  for (var i in str) {
    var newKey = i;
    if (i.indexOf('scene') > -1) {
      newKey = i.replace('{"scene":"', '');
    }
    if (/\}/.test(str[i])) {
      str[newKey] = str[i].replace('"}', '');
    }
    str2[newKey] = str[i];
  }
  return str2;
};

/**
 * json数据转为formdata
 * @param json json
 */
export var json2formdata = function json2formdata(json) {
  var data = new FormData();
  for (var i in json) {
    data.append(i, json[i]);
  }
  return data;
};
export var getRef = function getRef(title) {
  var _Object$values, _Object$values$find, _Object$values$find$r;
  var refs = commonPool.getRefs();
  return (_Object$values = Object.values(refs)) === null || _Object$values === void 0 ? void 0 : (_Object$values$find = _Object$values.find(function (item) {
    return item.title === title;
  })) === null || _Object$values$find === void 0 ? void 0 : (_Object$values$find$r = _Object$values$find.ref) === null || _Object$values$find$r === void 0 ? void 0 : _Object$values$find$r.current;
};
export var getSchema = function getSchema(type) {
  var _commonPool$getForm, _commonPool$getForm$c, _commonPool$getForm$c2, _commonPool$getForm$c3;
  var schema = ((_commonPool$getForm = commonPool.getForm()) === null || _commonPool$getForm === void 0 ? void 0 : (_commonPool$getForm$c = _commonPool$getForm.current) === null || _commonPool$getForm$c === void 0 ? void 0 : (_commonPool$getForm$c2 = _commonPool$getForm$c.getValue) === null || _commonPool$getForm$c2 === void 0 ? void 0 : (_commonPool$getForm$c3 = _commonPool$getForm$c2.call(_commonPool$getForm$c)) === null || _commonPool$getForm$c3 === void 0 ? void 0 : _commonPool$getForm$c3.properties) || {};
  if (type === 'all') return Object.keys(schema).map(function (item) {
    var _schema$item, _schema$item$props;
    var title = (_schema$item = schema[item]) === null || _schema$item === void 0 ? void 0 : (_schema$item$props = _schema$item.props) === null || _schema$item$props === void 0 ? void 0 : _schema$item$props.title;
    return {
      label: title,
      value: title
    };
  }).filter(function (item) {
    return item === null || item === void 0 ? void 0 : item.value;
  });else if (type === COMP_TYPE_SWIPER) return Object.keys(schema).filter(function (item) {
    var _schema$item2;
    return (schema === null || schema === void 0 ? void 0 : (_schema$item2 = schema[item]) === null || _schema$item2 === void 0 ? void 0 : _schema$item2.category) === COMP_TYPE_SWIPER;
  }).map(function (item) {
    var _schema$item3, _schema$item3$props;
    var title = (_schema$item3 = schema[item]) === null || _schema$item3 === void 0 ? void 0 : (_schema$item3$props = _schema$item3.props) === null || _schema$item3$props === void 0 ? void 0 : _schema$item3$props.title;
    return {
      label: title,
      value: title
    };
  }).filter(function (item) {
    return item === null || item === void 0 ? void 0 : item.value;
  });
  return Object.keys(schema).filter(function (item) {
    var _schema$item4;
    return (schema === null || schema === void 0 ? void 0 : (_schema$item4 = schema[item]) === null || _schema$item4 === void 0 ? void 0 : _schema$item4.category) === INTERACTION_TITLE_LIST[1];
  }).map(function (item) {
    var _schema$item5, _schema$item5$props;
    var title = (_schema$item5 = schema[item]) === null || _schema$item5 === void 0 ? void 0 : (_schema$item5$props = _schema$item5.props) === null || _schema$item5$props === void 0 ? void 0 : _schema$item5$props.title;
    return {
      label: title,
      value: title
    };
  }).filter(function (item) {
    return item === null || item === void 0 ? void 0 : item.value;
  });
};

/**
 * 打开新窗口，window.open 在ios中不可用
 */
export var openNewWindow = function openNewWindow(url) {
  if (!url) return;
  var anchor = document.createElement('a');
  anchor.style.display = 'none';
  anchor.target = '_blank';
  anchor.href = url;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
};

/**
 * 执行html片段中的script
 * @param html html片段
 */
export var executeScript = function executeScript(html) {
  var reg = /<script[^>]*>([^\x00]+)$/i;
  // 对整段HTML片段按<\/script>拆分
  var htmlBlock = html.split('</script>');
  for (var i in htmlBlock) {
    var blocks = void 0; // 匹配正则表达式的内容数组，blocks[1]就是真正的一段脚本内容，因为前面reg定义我们用了括号进行了捕获分组
    if (blocks = htmlBlock[i].match(reg)) {
      // 清除可能存在的注释标记，对于注释结尾-->可以忽略处理，eval一样能正常工作
      var code = blocks[1].replace(/<!--/, '');
      try {
        // eslint-disable-next-line no-eval
        eval(code); // 执行脚本
      } catch (e) {}
    }
  }
};
export var imgUpload = "".concat(getApigatewayHost(), "/base/v1/upload/upload");
export var imgPrefix = "".concat(getPrefix(), "simg01.gaodunwangxiao.com/");

/**
 * 补零
 * @param v 初始数字
 * @param l 补完0后长度 defaul:2
 */
export var patchZero = function patchZero(n) {
  var l = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var value = n.toString();
  var str = '';
  for (var i = value.length; i < l; i++) {
    str += '0';
  }
  return "".concat(str).concat(value);
};

/**
 * 图片加载失败
 * @description 静态图片资源加载失败后，切换 simg02，simg03 依次重试
 * @param e 图片对象
 */
export var picOnError = function picOnError(e) {
  var _img = e.target;
  var url = _img.src;
  var urlMatch = url.match(/simg(.*)\.gaodunwangxiao.com/);
  // 图片来源为simg*.gaodunwangxiao.com
  if (urlMatch) {
    var line = Number(urlMatch[1]);
    if (line < 3) {
      _img.src = url.replace(/(simg).*(\.gaodunwangxiao.com)/, "$1".concat(patchZero(line + 1, 2), "$2"));
    } else {
      var errorDom = document.createElement('div');
      errorDom.innerHTML = '加载失败！<br/>请检查网络态再刷新重试';
      errorDom.style.display = 'flex';
      errorDom.style.alignItems = 'center';
      errorDom.style.justifyContent = 'center';
      errorDom.style.width = '100%';
      errorDom.style.height = '200px';
      errorDom.style.maxHeight = '100%';
      errorDom.style.fontSize = '14px';
      errorDom.style.textAlign = 'center';
      errorDom.style.lineHeight = '22px';
      errorDom.style.color = '#aaa';
      errorDom.style.background = '#eee';
      _img.parentNode.replaceChild(errorDom, _img);
    }
  }
};

/**
 * 锚点跳转
 */
export var scrollToAnchor = function scrollToAnchor(id) {
  var _anchorElement$scroll;
  if (!id) return;
  var anchorElement = document.getElementById("me-".concat(id));
  anchorElement === null || anchorElement === void 0 ? void 0 : (_anchorElement$scroll = anchorElement.scrollIntoView) === null || _anchorElement$scroll === void 0 ? void 0 : _anchorElement$scroll.call(anchorElement, {
    behavior: 'smooth',
    block: 'start',
    inline: 'nearest'
  });
};
export var linkToUrl = function linkToUrl(url) {
  var _window;
  if (!url) return;
  (_window = window) === null || _window === void 0 ? void 0 : _window.open(url, '_blank');
};

/**
 * 处理url特殊参数
 * @scene参数在url中object对象处理
 */
export var getUrlParmas = function getUrlParmas(search) {
  var str = search;
  var str2 = {};
  for (var i in str) {
    var newKey = i;
    if (i.indexOf('scene') > -1) {
      newKey = i.replace('{"scene":"', '');
    }
    if (/\}/.test(str[i])) {
      str[newKey] = str[i].replace('"}', '');
    }
    str2[newKey] = str[i];
  }
  return str2;
};
export var timeJs = function timeJs(date) {
  dayjs.extend(weekday);
  dayjs.extend(localeData);
  return dayjs(date);
};

/**
 * 动态加载脚本并在加载完成后执行回调函数
 * @param {string} src - 脚本的 URL
 * @param {Function} callback - 脚本加载完成后的回调函数
 */
export function loadScript(src, callback) {
  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = src;

  // 脚本加载完成或加载失败时调用的处理函数
  script.onload = function () {
    if (callback) {
      callback();
    }
  };
  script.onerror = function () {
    if (callback) {
      callback(new Error("Failed to load script: ".concat(src)));
    }
  };

  // 将脚本标签添加到文档的 <head> 部分
  document.head.appendChild(script);
}